export const roles = {
  1: 'ADMIN',
  2: 'USER',
};
